import VBodyScrollLock from 'v-body-scroll-lock'

import Vue from 'vue'

export default Vue.use(VBodyScrollLock)

//disable scrool when modal open
//https://github.com/BramHoningh/vue-body-scroll-lock
